import { Directive, EventEmitter, TemplateRef, ViewContainerRef, EmbeddedViewRef } from "@angular/core";

export class MultiviewContentVisibilityChangedEvent {
    public sender: MultiviewContentDirective;
    public visibility: boolean;

    constructor(sender: MultiviewContentDirective, visibility: boolean) {
        this.sender = sender;
        this.visibility = visibility;
    }
}

@Directive({
    selector: '[multiviewContent]',
    standalone: false
})
export class MultiviewContentDirective {
    private embeddedView: EmbeddedViewRef<any>;

    private mVisible: boolean = false;
    public set visible(value: boolean) {
        if (this.mVisible != value) {
            this.mVisible = value;
            if (value) {
                this.embeddedView = this.viewContainerRef.createEmbeddedView(this.templateRef);
            } else {
                this.viewContainerRef.clear();
                this.embeddedView = null;
            }

            this.onVisibilityChanged.emit(new MultiviewContentVisibilityChangedEvent(this,value));
        }
    }

    public onVisibilityChanged: EventEmitter<MultiviewContentVisibilityChangedEvent> = new EventEmitter<MultiviewContentVisibilityChangedEvent>();

    public get visible(): boolean {
        return this.mVisible;
    }

    public setVisibleWithContext(context: any)  {
        this.viewContainerRef.clear();
        this.embeddedView = this.viewContainerRef.createEmbeddedView(this.templateRef, context);
        this.mVisible = true;
        this.onVisibilityChanged.emit(new MultiviewContentVisibilityChangedEvent(this, true));
    }

    constructor(private templateRef: TemplateRef<any>, private viewContainerRef: ViewContainerRef) {
        
    }
}